import { render, staticRenderFns } from "./ProfileBasic.vue?vue&type=template&id=2028a54a"
import script from "./ProfileBasic.vue?vue&type=script&lang=ts"
export * from "./ProfileBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2028a54a')) {
      api.createRecord('2028a54a', component.options)
    } else {
      api.reload('2028a54a', component.options)
    }
    module.hot.accept("./ProfileBasic.vue?vue&type=template&id=2028a54a", function () {
      api.rerender('2028a54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileBasic.vue"
export default component.exports